import { reactive, computed } from 'vue';
import useVuelidate from '@vuelidate/core';
// eslint-disable-next-line object-curly-newline
import { required, email } from '@vuelidate/validators';

export const usePqrsForm = () => {
    const state = reactive({
        id: '',
        tipo: '',
        nombre: '',
        telefono: '',
        email: '',
        mensaje: '',
        status: 1,
    });

    const setState = (c) => {
        state.id = c.id;
        state.tipo = c.type;
        state.nombre = c.name;
        state.telefono = c.phone;
        state.email = c.email;
        state.mensaje = c.message;
        state.status = c.status;
    };

    const rules = computed(() => ({
        tipo: { required },
        nombre: { required },
        telefono: { required },
        email: { required, email },
        mensaje: { required },
    }));

    const $v = useVuelidate(rules, state);

    return {
        state,
        setState,
        $v,
        rules
    };
};

export default {};
